// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resource-library {
  padding: 20px;
  background: transparent;
  border-radius: 12px;
  transition: all 0.3s ease;
}

/* Header styles */
.resource-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.resource-header h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin: 0;
  transition: color 0.3s ease;
  font-weight: 600;
}

.dark-mode .resource-header h2 {
  color: #f5f5f5;
}

.add-resource-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #2ecc71;
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px rgba(46, 204, 113, 0.2);
}

.add-resource-btn:hover {
  background: #27ae60;
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(46, 204, 113, 0.25);
}

.dark-mode .add-resource-btn {
  box-shadow: 0 4px 6px rgba(46, 204, 113, 0.3);
}

.dark-mode .add-resource-btn:hover {
  box-shadow: 0 6px 8px rgba(46, 204, 113, 0.4);
}

/* Search and filters */
.resource-filters {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.search-bar {
  position: relative;
  flex: 1 1;
  min-width: 250px;
  margin-right: 16px;
}

.search-bar input {
  width: 100%;
  padding: 12px 16px 12px 42px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: #fff;
  color: #333;
}

.dark-mode .search-bar input {
  background: #2d2d2d;
  border-color: #444;
  color: #f5f5f5;
}

.search-bar input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.dark-mode .search-bar input:focus {
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

.search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #95a5a6;
  pointer-events: none;
}

.dark-mode .search-icon {
  color: #777;
}

.category-filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 16px;
  width: 100%;
}

.category-filters button {
  padding: 8px 16px;
  background: transparent;
  border: 2px solid #3498db;
  border-radius: 8px;
  color: #3498db;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.category-filters button:hover {
  background: rgba(52, 152, 219, 0.1);
}

.dark-mode .category-filters button {
  border-color: #4CA1D8;
  color: #4CA1D8;
}

.dark-mode .category-filters button:hover {
  background: rgba(76, 161, 216, 0.1);
}

.category-filters button.active {
  background: #3498db;
  color: white;
}

.dark-mode .category-filters button.active {
  background: #4CA1D8;
}

/* Add resource form */
.add-resource-form {
  background: #f8f9fa;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 32px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.dark-mode .add-resource-form {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.add-resource-form h3 {
  color: #2c3e50;
  margin: 0 0 24px 0;
  font-size: 1.4rem;
  font-weight: 600;
}

.dark-mode .add-resource-form h3 {
  color: #f5f5f5;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #2c3e50;
  margin-bottom: 8px;
  font-weight: 500;
}

.dark-mode .form-group label {
  color: #e0e0e0;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: #fff;
  color: #333;
}

.dark-mode .form-group input,
.dark-mode .form-group textarea,
.dark-mode .form-group select {
  background: #3d3d3d;
  border-color: #555;
  color: #f5f5f5;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.dark-mode .form-group input:focus,
.dark-mode .form-group textarea:focus,
.dark-mode .form-group select:focus {
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

.form-group textarea {
  min-height: 120px;
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.form-actions {
  display: flex;
  gap: 16px;
  margin-top: 24px;
  flex-wrap: wrap;
}

.submit-btn,
.cancel-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.submit-btn {
  background: #3498db;
  color: white;
}

.submit-btn:hover {
  background: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);
}

.dark-mode .submit-btn:hover {
  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.3);
}

.cancel-btn {
  background: #e74c3c;
  color: white;
}

.cancel-btn:hover {
  background: #c0392b;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(231, 76, 60, 0.2);
}

.dark-mode .cancel-btn:hover {
  box-shadow: 0 4px 6px rgba(231, 76, 60, 0.3);
}

/* Resources grid */
.resources-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
}

.resource-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .resource-card {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.resource-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.dark-mode .resource-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.resource-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 16px;
  color: #3498db;
  font-size: 1.5rem;
}

.dark-mode .resource-icon {
  background: #3d3d3d;
  color: #4CA1D8;
}

.resource-content {
  padding: 20px;
  flex: 1 1;
}

.resource-type {
  display: inline-block;
  padding: 5px 10px;
  background: rgba(52, 152, 219, 0.1);
  color: #3498db;
  border-radius: 6px;
  font-size: 0.8rem;
  margin-bottom: 12px;
  font-weight: 500;
}

.dark-mode .resource-type {
  background: rgba(76, 161, 216, 0.2);
  color: #4CA1D8;
}

.resource-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #2c3e50;
  line-height: 1.4;
}

.dark-mode .resource-title {
  color: #f5f5f5;
}

.resource-description {
  color: #7f8c8d;
  margin: 0 0 16px 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dark-mode .resource-description {
  color: #bbb;
}

.resource-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #95a5a6;
  font-size: 0.85rem;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .resource-meta {
  color: #999;
  border-top-color: rgba(255, 255, 255, 0.05);
}

.resource-date {
  font-style: italic;
}

.resource-actions {
  margin-top: 16px;
  display: flex;
  gap: 8px;
}

.action-button {
  padding: 8px;
  border: none;
  background: transparent;
  color: #7f8c8d;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.dark-mode .action-button {
  color: #bbb;
}

.action-button:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #3498db;
}

.dark-mode .action-button:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #4CA1D8;
}

.resource-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #3498db;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  margin-top: 16px;
  transition: all 0.2s ease;
}

.resource-link:hover {
  background: #2980b9;
  transform: translateY(-2px);
}

/* Empty state */
.no-resources {
  text-align: center;
  padding: 48px 24px;
  color: #7f8c8d;
  background: #f8f9fa;
  border-radius: 12px;
  margin-top: 24px;
}

.dark-mode .no-resources {
  color: #bbb;
  background: #2d2d2d;
}

.empty-state {
  font-size: 1.1rem;
  margin: 16px 0;
  line-height: 1.5;
}

.dark-mode .empty-state {
  color: #e0e0e0;
}

.empty-state-icon {
  font-size: 3rem;
  color: #3498db;
  margin-bottom: 16px;
}

.dark-mode .empty-state-icon {
  color: #4CA1D8;
}

/* Loading and error states */
.loading-spinner, 
.error-message {
  text-align: center;
  padding: 40px;
  font-size: 1.1rem;
  color: #7f8c8d;
}

.dark-mode .loading-spinner,
.dark-mode .error-message {
  color: #bbb;
}

.retry-button {
  display: inline-block;
  margin-top: 16px;
  padding: 8px 16px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.retry-button:hover {
  background: #2980b9;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .resource-library {
    padding: 16px;
  }
  
  .resource-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 24px;
  }

  .resource-header h2 {
    font-size: 1.6rem;
  }

  .add-resource-btn {
    width: 100%;
    justify-content: center;
  }

  .search-bar {
    width: 100%;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .submit-btn, 
  .cancel-btn {
    width: 100%;
  }
  
  .resources-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .resource-filters {
    gap: 12px;
  }
  
  .category-filters {
    gap: 8px;
  }
  
  .category-filters button {
    padding: 6px 12px;
    font-size: 0.9rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/StudyTools/ResourceLibrary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;EAGE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;;EAEE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".resource-library {\n  padding: 20px;\n  background: transparent;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n}\n\n/* Header styles */\n.resource-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.resource-header h2 {\n  font-size: 1.8rem;\n  color: #2c3e50;\n  margin: 0;\n  transition: color 0.3s ease;\n  font-weight: 600;\n}\n\n.dark-mode .resource-header h2 {\n  color: #f5f5f5;\n}\n\n.add-resource-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background: #2ecc71;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 6px rgba(46, 204, 113, 0.2);\n}\n\n.add-resource-btn:hover {\n  background: #27ae60;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 8px rgba(46, 204, 113, 0.25);\n}\n\n.dark-mode .add-resource-btn {\n  box-shadow: 0 4px 6px rgba(46, 204, 113, 0.3);\n}\n\n.dark-mode .add-resource-btn:hover {\n  box-shadow: 0 6px 8px rgba(46, 204, 113, 0.4);\n}\n\n/* Search and filters */\n.resource-filters {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n}\n\n.search-bar {\n  position: relative;\n  flex: 1;\n  min-width: 250px;\n  margin-right: 16px;\n}\n\n.search-bar input {\n  width: 100%;\n  padding: 12px 16px 12px 42px;\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: #fff;\n  color: #333;\n}\n\n.dark-mode .search-bar input {\n  background: #2d2d2d;\n  border-color: #444;\n  color: #f5f5f5;\n}\n\n.search-bar input:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n}\n\n.dark-mode .search-bar input:focus {\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\n}\n\n.search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #95a5a6;\n  pointer-events: none;\n}\n\n.dark-mode .search-icon {\n  color: #777;\n}\n\n.category-filters {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 16px;\n  width: 100%;\n}\n\n.category-filters button {\n  padding: 8px 16px;\n  background: transparent;\n  border: 2px solid #3498db;\n  border-radius: 8px;\n  color: #3498db;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.category-filters button:hover {\n  background: rgba(52, 152, 219, 0.1);\n}\n\n.dark-mode .category-filters button {\n  border-color: #4CA1D8;\n  color: #4CA1D8;\n}\n\n.dark-mode .category-filters button:hover {\n  background: rgba(76, 161, 216, 0.1);\n}\n\n.category-filters button.active {\n  background: #3498db;\n  color: white;\n}\n\n.dark-mode .category-filters button.active {\n  background: #4CA1D8;\n}\n\n/* Add resource form */\n.add-resource-form {\n  background: #f8f9fa;\n  padding: 24px;\n  border-radius: 12px;\n  margin-bottom: 32px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .add-resource-form {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.add-resource-form h3 {\n  color: #2c3e50;\n  margin: 0 0 24px 0;\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.dark-mode .add-resource-form h3 {\n  color: #f5f5f5;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  color: #2c3e50;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.dark-mode .form-group label {\n  color: #e0e0e0;\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: #fff;\n  color: #333;\n}\n\n.dark-mode .form-group input,\n.dark-mode .form-group textarea,\n.dark-mode .form-group select {\n  background: #3d3d3d;\n  border-color: #555;\n  color: #f5f5f5;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n}\n\n.dark-mode .form-group input:focus,\n.dark-mode .form-group textarea:focus,\n.dark-mode .form-group select:focus {\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\n}\n\n.form-group textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 16px;\n  margin-top: 24px;\n  flex-wrap: wrap;\n}\n\n.submit-btn,\n.cancel-btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.submit-btn {\n  background: #3498db;\n  color: white;\n}\n\n.submit-btn:hover {\n  background: #2980b9;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);\n}\n\n.dark-mode .submit-btn:hover {\n  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.3);\n}\n\n.cancel-btn {\n  background: #e74c3c;\n  color: white;\n}\n\n.cancel-btn:hover {\n  background: #c0392b;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px rgba(231, 76, 60, 0.2);\n}\n\n.dark-mode .cancel-btn:hover {\n  box-shadow: 0 4px 6px rgba(231, 76, 60, 0.3);\n}\n\n/* Resources grid */\n.resources-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 24px;\n}\n\n.resource-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .resource-card {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.resource-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.dark-mode .resource-card:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.resource-icon {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 12px;\n  margin-bottom: 16px;\n  color: #3498db;\n  font-size: 1.5rem;\n}\n\n.dark-mode .resource-icon {\n  background: #3d3d3d;\n  color: #4CA1D8;\n}\n\n.resource-content {\n  padding: 20px;\n  flex: 1;\n}\n\n.resource-type {\n  display: inline-block;\n  padding: 5px 10px;\n  background: rgba(52, 152, 219, 0.1);\n  color: #3498db;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.dark-mode .resource-type {\n  background: rgba(76, 161, 216, 0.2);\n  color: #4CA1D8;\n}\n\n.resource-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n  color: #2c3e50;\n  line-height: 1.4;\n}\n\n.dark-mode .resource-title {\n  color: #f5f5f5;\n}\n\n.resource-description {\n  color: #7f8c8d;\n  margin: 0 0 16px 0;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.dark-mode .resource-description {\n  color: #bbb;\n}\n\n.resource-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #95a5a6;\n  font-size: 0.85rem;\n  margin-top: auto;\n  padding-top: 16px;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .resource-meta {\n  color: #999;\n  border-top-color: rgba(255, 255, 255, 0.05);\n}\n\n.resource-date {\n  font-style: italic;\n}\n\n.resource-actions {\n  margin-top: 16px;\n  display: flex;\n  gap: 8px;\n}\n\n.action-button {\n  padding: 8px;\n  border: none;\n  background: transparent;\n  color: #7f8c8d;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.dark-mode .action-button {\n  color: #bbb;\n}\n\n.action-button:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #3498db;\n}\n\n.dark-mode .action-button:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #4CA1D8;\n}\n\n.resource-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: #3498db;\n  color: white;\n  text-decoration: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin-top: 16px;\n  transition: all 0.2s ease;\n}\n\n.resource-link:hover {\n  background: #2980b9;\n  transform: translateY(-2px);\n}\n\n/* Empty state */\n.no-resources {\n  text-align: center;\n  padding: 48px 24px;\n  color: #7f8c8d;\n  background: #f8f9fa;\n  border-radius: 12px;\n  margin-top: 24px;\n}\n\n.dark-mode .no-resources {\n  color: #bbb;\n  background: #2d2d2d;\n}\n\n.empty-state {\n  font-size: 1.1rem;\n  margin: 16px 0;\n  line-height: 1.5;\n}\n\n.dark-mode .empty-state {\n  color: #e0e0e0;\n}\n\n.empty-state-icon {\n  font-size: 3rem;\n  color: #3498db;\n  margin-bottom: 16px;\n}\n\n.dark-mode .empty-state-icon {\n  color: #4CA1D8;\n}\n\n/* Loading and error states */\n.loading-spinner, \n.error-message {\n  text-align: center;\n  padding: 40px;\n  font-size: 1.1rem;\n  color: #7f8c8d;\n}\n\n.dark-mode .loading-spinner,\n.dark-mode .error-message {\n  color: #bbb;\n}\n\n.retry-button {\n  display: inline-block;\n  margin-top: 16px;\n  padding: 8px 16px;\n  background: #3498db;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.retry-button:hover {\n  background: #2980b9;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .resource-library {\n    padding: 16px;\n  }\n  \n  .resource-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n\n  .resource-header h2 {\n    font-size: 1.6rem;\n  }\n\n  .add-resource-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .search-bar {\n    width: 100%;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n  \n  .submit-btn, \n  .cancel-btn {\n    width: 100%;\n  }\n  \n  .resources-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .resource-filters {\n    gap: 12px;\n  }\n  \n  .category-filters {\n    gap: 8px;\n  }\n  \n  .category-filters button {\n    padding: 6px 12px;\n    font-size: 0.9rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
